"use client";
import {
  TimeCalendar,
  WeatherWind,
  GeneralLocationPin,
} from "@fanduel/formation-react-icons";
import TvSvg from "@/components/scoreboard/TvSvg";
import CoveredStadiumIcon from "@/components/svg/weather/CoveredStadium";
import { EventWeather } from "@/graphql/gql/graphql";
import { getFormattedDayMonthYearTimeWithTZ } from "@/utils/date";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import TimeStampClient from "@/utils/TimeStampClient";
import WeatherIcon from "../../svg/weather/WeatherIcon";
import styles from "./gameInfo.module.scss";

export function getNetworkDisplayName(
  isMobile: boolean,
  networkName?: string | null
): string {
  if (!networkName) return "-";

  if (isMobile && networkName === "Amazon Prime Video") {
    return "Prime";
  }

  return networkName;
}

interface GameInfoProps {
  isMobile?: boolean;
  weather?: EventWeather | null;
}

const GameInfo = ({ isMobile, weather }: GameInfoProps) => {
  const {
    startTime = "",
    broadcastInfo,
    venueName,
    venueType,
  } = useHeadToHeadContext();

  const smallIconSize = 16;
  const { condition, humidity, tempInF, windSpeedInMph } = weather ?? {};

  const indoorTypes = ["indoor", "covered", "dome"];
  const isIndoor = venueType && indoorTypes.includes(venueType.toLowerCase());
  const hasWeatherInfo = !isIndoor && tempInF !== undefined && condition;

  return (
    <div className={styles.gameInfo}>
      <div className={styles.infoLeft}>
        <div>
          <TimeCalendar width={smallIconSize} height={smallIconSize} />
          <p>
            <TimeStampClient
              isoString={startTime}
              formatter={getFormattedDayMonthYearTimeWithTZ}
            />
          </p>
        </div>
        {broadcastInfo?.network != null && (
          <div>
            <TvSvg />
            <p>
              {getNetworkDisplayName(isMobile ?? false, broadcastInfo.network)}
            </p>
          </div>
        )}
        {venueName != null && venueName !== "" && (
          <div>
            <GeneralLocationPin width={smallIconSize} height={smallIconSize} />
            <p>{venueName}</p>
          </div>
        )}
        {isIndoor && (
          <div>
            <CoveredStadiumIcon width={smallIconSize} height={smallIconSize} />
            <p>Indoor Stadium</p>
          </div>
        )}
      </div>

      {!isIndoor && hasWeatherInfo && (
        <div className={styles.infoRight}>
          <div>
            <WeatherIcon
              width={smallIconSize}
              height={smallIconSize}
              condition={condition}
            />
            <p>
              {tempInF}ºF | {humidity}% Humidity
            </p>
          </div>
          {windSpeedInMph !== undefined && (
            <div>
              <WeatherWind width={smallIconSize} height={smallIconSize} />
              <p>{`${windSpeedInMph} mph`}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GameInfo;
